// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myMenu {
  width: 100%;
}

.myMenu-title {
  font-weight: 600;
  font-size: 16px;
  color: #444;
  display: inline-block;
  margin-bottom: 8px;
}

.myMenu-swiper {
  padding: 6px 0;
}

/* 칩 버튼 */
.myMenu-slide {
  width: auto;
  /* slidesPerView="auto"일 때 칩 크기만큼 */
}

.myMenu-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 9999px;
  border: 1px solid rgba(22, 99, 156, 0.10);
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  transition: transform .06s ease, background .15s ease;
  cursor: pointer;
}

.myMenu-chip:active {
  transform: scale(0.98);
}

.myMenu-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #E6F0F8;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
}

.myMenu-label {
  color: #1F2A37;
  font-weight: 600;
  font-size: 14px;
}

/* (선택) 스크롤바 최소화 - WebKit */
.myMenu-swiper::-webkit-scrollbar {
  height: 6px;
}

.myMenu-swiper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 999px;
}

.myMenu-swiper .swiper-slide {
  width: auto !important;
  /* slidesPerView="auto"와 세트 */
  display: inline-flex;
  /* 칩 너비만큼만 차지 */
  flex-shrink: 0;
}

.swiper-wrapper {
  height: auto !important;
  margin-bottom: 10px !important;
}

/* mobile-dashboard.css */
.mobile-dashboard-panel {
  width: 100%;
  padding: 30px 20px 10px;
  box-sizing: border-box;
  background: linear-gradient(160deg, #0b3a6f 0%, #0d2b53 60%, #08223f 100%);
  color: #fff;
}

/* 상단 텍스트 */
.mobile-dashboard-welcome {
  padding: 6px 4px 14px;
}

.mobile-dashboard-welcome-title {
  font-size: 20px;
  line-height: 1.3;
  font-weight: 700;
  margin: 0 0 6px 0;
  letter-spacing: -0.2px;
}

.mobile-dashboard-welcome-sub {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-dashboard-welcome-badge {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: #d7e2ef;
}

/* 잔고 카드 */
.mobile-dashboard-balance-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px 12px;
  color: #0d1b2a;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  /* max-width: 360px; */
}

.mobile-dashboard-balance-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.mobile-dashboard-balance-label {
  font-size: 12px;
  color: #7a8a9e;
  font-weight: 600;
  letter-spacing: -0.2px;
}

.mobile-dashboard-balance-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-dashboard-balance-amount {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.mobile-dashboard-balance-amount .unit {
  font-size: 18px;
  margin-left: 2px;
  font-weight: 600;
}

.mobile-dashboard-refresh-btn {
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  border-radius: 6px;
  color: #0c3b70;
  cursor: pointer;
}

.mobile-dashboard-refresh-btn:active {
  transform: scale(0.96);
}

.mobile-dashboard-refresh-btn:hover {
  background: rgba(12, 59, 112, 0.08);
}

/* 반응형 */
@media (max-width: 420px) {
  .mobile-dashboard-panel {
    border-radius: 0;
    padding: 16px;
  }

  .mobile-dashboard-balance-card {
    max-width: 100%;
  }

  .mobile-dashboard-balance-amount {
    font-size: 26px;
  }
}

/* ===== 모달 전체 ===== */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-sheet {
  background: #fff;
  width: 400px;
  max-width: 90%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.2s ease;
  display: flex;
  flex-direction: column;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== 모달 헤더 ===== */
.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 20px 16px;
  border-bottom: 1px solid #eee;
}

.modal-head h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
  color: #666;
}

/* ===== 모달 바디 ===== */
.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-label {
  font-size: 14px;
  color: #555;
}

.row-content {
  font-size: 16px;
  font-weight: 500;
}

/* ===== 입력 ===== */
.amount-input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.amount-input {
  flex: 1 1;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 15px;
  text-align: right;
}

.amount-suffix {
  font-size: 14px;
  color: #333;
}

.btn-all {
  padding: 6px 12px;
  border: none;
  background: #f1f1f1;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.btn-all:hover {
  background: #e2e2e2;
}

/* ===== 에러 메시지 ===== */
.field-error {
  font-size: 12px;
  color: #d33;
}

/* ===== 모달 푸터 ===== */
.modal-foot {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.btn-transfer {
  background: #004080;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-transfer:hover {
  background: #003366;
}

.btn-transfer.btn-disabled {
  background: #bbb;
  cursor: not-allowed;
}

.mobile-date {
  font-size: 14px;
}

.mobile-date-btn:hover {
  background-color: #f1f1f1;
}

/* MobileCreateInfo.css */
.mobile-url-create-wrap {
  background: #fff;
  color: #111827;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans KR", Arial, sans-serif;
}

.mobile-url-create-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.mobile-url-create-section {
  margin-bottom: 20px;
}

.mobile-url-create-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.mobile-url-create-image-row {
  display: flex;
  gap: 12px;
}

.mobile-url-create-image-box,
.mobile-url-create-image-picker {
  width: 120px;
  height: 90px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-url-create-image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.mobile-url-create-image-picker {
  cursor: pointer;
  background: #ffffff;
  flex-direction: column;
  gap: 6px;
}

.mobile-url-create-plus {
  width: 26px;
  height: 26px;
  position: relative;
  display: inline-block;
}

.mobile-url-create-plus::before,
.mobile-url-create-plus::after {
  content: "";
  position: absolute;
  background: #9ca3af;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.mobile-url-create-plus::before {
  width: 2px;
  height: 20px;
}

.mobile-url-create-plus::after {
  width: 20px;
  height: 2px;
}

.mobile-url-create-form {
  margin-top: 10px;
  display: grid;
  gap: 7px;
}

.mobile-url-create-field {
  display: grid;
  gap: 1px;
}

.mobile-url-create-field-label {
  font-size: 12px;
  color: #6b7280;
}

.mobile-url-create-input,
.mobile-url-create-textarea,
.mobile-url-create-select {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 12px;
  height: 34px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  font-size: 14px;
  outline: none;
}

.mobile-url-create-input::placeholder,
.mobile-url-create-textarea::placeholder {
  color: #9ca3af;
}

.mobile-url-create-textarea {
  resize: vertical;
  min-height: 88px;
}

/* 셀렉트 + 케럿 */
.mobile-url-create-select-wrap {
  position: relative;
}

.mobile-url-create-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.mobile-url-create-caret {
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #6b7280;
  transform: translateY(-50%);
  pointer-events: none;
}

.mobile-url-create-divider {
  height: 5px;
  background: #f3f4f6;
  margin: 0px -20px 14px;
}

.mobile-url-create-actions {
  display: flex;
  gap: 12px;
}

.mobile-url-create-btn {
  flex: 1 1;
  height: 44px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
}

.mobile-url-create-btn.primary {
  background: #003577;
  /* 딥 블루-민트 */
  color: #fff;
  border-color: #003577;
}

.mobile-url-create-btn.ghost {
  background: #fff;
  color: #374151;
}

.mobile-url-create-btn:active {
  transform: translateY(1px);
}

/* 설명 이미지 썸네일 그리드 */
.mobile-url-create-desc-row {
  margin: 8px 0 6px;
}

.mobile-url-create-thumb-grid {
  margin-top: 6px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.mobile-url-create-thumb {
  position: relative;
  width: 100%;
  padding-top: 75%;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background: #f9fafb;
}

.mobile-url-create-thumb img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-url-create-thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: rgba(17, 24, 39, 0.65);
  color: #fff;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
}

.mobile-url-create-sublabel {
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 6px;
}

.mobile-url-create-image-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 대표이미지 박스 */
.mobile-url-create-image-box-rep {
  position: relative;
}

.mobile-url-create-image-box-rep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

/* MobileManagement.css */
.mobile-management-wrap {
  padding: 70px 16px 16px;
  background: #fff;
  color: #111827;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans KR", Arial, sans-serif;
}

.mobile-management-heading {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.mobile-management-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.mobile-management-card {
  display: flex;
  flex-direction: column;
}

.mobile-management-thumb {
  position: relative;
  width: 100%;
  padding-top: 100%;
  /* 1:1 */
  border-radius: 12px;
  overflow: hidden;
  background: #f3f4f6;
}

.mobile-management-thumb img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-management-like {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e7eb;
  display: grid;
  place-items: center;
  color: #6b7280;
}

.mobile-management-title {
  margin: 8px 2px 6px;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 2줄 말줄임 */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mobile-management-price-row {
  margin: 0 2px 4px;
  display: flex;
  gap: 6px;
  align-items: baseline;
}

.mobile-management-discount {
  color: #ef4444;
  /* 붉은 할인 퍼센트 */
  font-weight: 800;
  font-size: 14px;
}

.mobile-management-price {
  font-weight: 800;
  font-size: 16px;
}

.mobile-management-myprice {
  margin: 0 2px 6px;
  color: #ef4444;
  font-size: 12px;
}

.mobile-management-myprice strong {
  font-weight: 800;
}

.mobile-management-badges {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin: 2px 2px 0;
}

.mobile-management-badge {
  font-size: 11px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 6px;
  border-radius: 999px;
}





/* ============== Base ============== */
.urlDetail-wrap {
  --ui-text: #111;
  --ui-muted: #6b7280;
  --ui-line: #e5e7eb;
  --ui-primary: #0b3a6f;
  /* 페이지 하단 결제/모달 버튼 */
  --ui-red: #ef4444;
  --ui-cta: #fbbf24;
  background: #fff;
  color: var(--ui-text);
  line-height: 1.4;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans KR", "Malgun Gothic", Pretendard, sans-serif;
}

/* ============== Hero (single image) ============== */
.urlDetail-hero {
  position: relative;
  background: #fff
}

.urlDetail-heroImg {
  width: 100%;
  display: block;
  aspect-ratio: 12/9;
  object-fit: cover
}

/* ============== Title / Meta ============== */
.urlDetail-titleBox {
  padding: 18px 16px 4px
}

.urlDetail-title {
  font-size: 18px;
  font-weight: 700;
  word-break: keep-all
}

.urlDetail-origin {
  color: var(--ui-muted);
  font-weight: 500;
  margin-left: 4px
}

.urlDetail-ratingLine {
  margin-top: 6px;
  color: var(--ui-red);
  font-weight: 700
}

.urlDetail-star {
  margin-right: 4px
}

.urlDetail-recent,
.urlDetail-reviews {
  color: var(--ui-muted);
  font-weight: 500
}

/* ============== Price ============== */
.urlDetail-priceBox {
  padding: 8px 16px 0
}

.urlDetail-priceRow {
  display: flex;
  align-items: baseline;
  gap: 10px
}

.urlDetail-priceRow--strike {
  color: var(--ui-muted);
  margin-top: 6px
}

.urlDetail-discount {
  color: var(--ui-red);
  font-size: 18px
}

.urlDetail-listPrice {
  text-decoration: line-through
}

.urlDetail-salePrice {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -.5px
}

.urlDetail-myPrice {
  margin-top: 6px;
  color: var(--ui-red);
  font-weight: 800
}

.urlDetail-myPrice span {
  margin-left: 6px;
  font-size: 13px;
  font-weight: 700
}

.urlDetail-shipLine {
  margin-top: 8px;
  display: flex;
  gap: 8px;
  color: var(--ui-muted)
}

.urlDetail-freeShip {
  padding: 2px 8px;
  border: 1px solid var(--ui-line);
  border-radius: 999px;
  color: #4b5563;
  background: #fff
}

.urlDetail-unit {
  color: var(--ui-muted)
}

/* ============== Benefit + 배송(원복) ============== */
.urlDetail-benefitWrap {
  padding: 14px 16px;
  display: grid;
  gap: 8px
}

.urlDetail-benefit {
  background: #ede9fe;
  color: #4f46e5;
  font-weight: 700;
  padding: 10px 12px;
  border-radius: 12px
}

.urlDetail-delivery {
  background: #ecfeff;
  color: #0ea5b7;
  font-weight: 700;
  padding: 10px 12px;
  border-radius: 12px
}

.urlDetail-nologo {
  display: inline-block;
  margin-right: 6px
}

/* ============== Tabs (상세정보만) ============== */
.urlDetail-tabs {
  display: flex;
  gap: 16px;
  padding: 12px 16px;
  border-top: 8px solid #f5f5f6;
  border-bottom: 1px solid var(--ui-line);
  background: #fff;
}

.urlDetail-tab {
  font-weight: 700;
  color: #111;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}

.urlDetail-tab.is-active {
  border-bottom-color: #111;
}

/* ✅ after 없이 밑줄 */

/* ============== Detail (상품정보 + 이미지 + 토글) ============== */
.urlDetail-detailBody {
  position: relative
}

.urlDetail-detailInner {
  padding: 6px 0 0
}

.urlDetail-detailImg {
  width: 100%;
  display: block
}

/* 접힘 높이 400px */
.urlDetail-detailBody.is-closed .urlDetail-detailInner {
  max-height: 400px;
  overflow: hidden
}

.urlDetail-detailFade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  height: 30px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 55%);
  pointer-events: none;
}

/* 상품정보 블록 */
.urlDetail-spec {
  padding: 16px
}

.urlDetail-specTitle {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 8px
}

.urlDetail-specTable {
  display: grid;
  grid-template-columns: 90px 1fr;
  row-gap: 8px;
  column-gap: 12px
}

.urlDetail-specTable dt {
  color: var(--ui-muted)
}

.urlDetail-specTable dd {
  color: #111
}

.urlDetail-spec--inDetail {
  border-bottom: 1px solid var(--ui-line);
  margin-bottom: 8px
}

/* 토글 버튼 */
.urlDetail-detailToggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: calc(100% - 32px);
  margin: 12px auto 16px;
  padding: 13px 12px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.urlDetail-toggleIcon {
  transition: transform .18s ease
}

.urlDetail-toggleIcon.is-open {
  transform: rotate(180deg)
}

.urlDetail-toggleText {
  display: inline-block
}

/* ============== Buy bar (하단 결제 버튼, #0b3a6f) ============== */
.urlDetail-bottomPad {
  height: 78px
}

.urlDetail-buybar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 40;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  padding: 10px 12px 15px;
  background: #fff;
  border-top: 1px solid var(--ui-line);
}

.urlDetail-buyBtn {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ui-primary);
  color: #fff;
  font-weight: 900;
  border-radius: 12px;
  padding: 16px 10px;
  font-size: 17px;
  cursor: pointer;
}

/* ============== Bottom Sheet (바텀시트 공통) ============== */
.urlDetail-sheet {
  position: fixed;
  inset: 0;
  z-index: 90;
  pointer-events: none
}

.urlDetail-sheet.is-open {
  pointer-events: auto
}

.urlDetail-sheetDim {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  opacity: 0;
  transition: opacity .2s ease
}

.urlDetail-sheet.is-open .urlDetail-sheetDim {
  opacity: 1
}

.urlDetail-sheetPanel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -12px 24px rgba(0, 0, 0, .18);
  transform: translateY(100%);
  transition: transform .28s ease;
  padding-bottom: env(safe-area-inset-bottom)
}

.urlDetail-sheet.is-open .urlDetail-sheetPanel {
  transform: translateY(0)
}

.urlDetail-sheetHandle {
  width: 44px;
  height: 4px;
  background: #e5e7eb;
  border-radius: 999px;
  margin: 10px auto 6px
}

.urlDetail-sheetBody {
  padding: 12px 16px
}

/* ============== 모달: 카드 + 총 결제 + 하단 버튼 ============== */
.urlDetail-payCard {
  margin: 20px 16px 0;
  padding: 0 5px;
  background: #fff;
}

.urlDetail-payHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px
}

.urlDetail-payText {
  min-width: 0
}

.urlDetail-payTitle {
  display: block;
  font-weight: 800
}

.urlDetail-payBrand {
  margin-top: 2px;
  color: var(--ui-muted);
  font-weight: 600;
  font-size: 13px
}

.urlDetail-payClose {
  all: unset;
  font-size: 20px;
  line-height: 1;
  padding: 4px;
  cursor: pointer
}

.urlDetail-payRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--ui-line)
}

.urlDetail-payPrice {
  font-weight: 800
}

.urlDetail-totalRow {
  margin: 0px 16px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  background: #fff;
}

.urlDetail-total {
  font-weight: 900
}

.urlDetail-sheetBuybar {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--ui-line);
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.urlDetail-ellipsis {
  max-width: 86vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.urlDetail-muted {
  color: var(--ui-muted)
}

/* ===== 모달 수량 스텝퍼 ===== */
.urlDetail-qtyCard {
  margin: 12px 16px;
}

.urlDetail-qtyRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--ui-line);
  border-bottom: none;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 12px 12px 6px;
  background: #fff;
}

.urlDetail-qtyTitle {
  font-weight: 800;
}

.urlDetail-stepper {
  display: flex;
  align-items: center;
}

.urlDetail-stepBtn {
  width: 42px;
  height: 42px;
  border: 1px solid var(--ui-line);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.urlDetail-stepBtn:first-child {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.urlDetail-stepBtn:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.urlDetail-stepBtn:disabled {
  opacity: .5;
  cursor: not-allowed;
  background: #fafafa;
}

.urlDetail-stepValue {
  width: 56px;
  height: 42px;
  border-top: 1px solid var(--ui-line);
  border-bottom: 1px solid var(--ui-line);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  background: #fff;
}

.urlDetail-qtySummary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--ui-line);
  border-top: none;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 12px;
  background: #fff;
}

.urlDetail-accent {
  color: var(--ui-red);
}




/* 래퍼: 헤더 높이(3.5rem) 아래부터 전체 화면 채움 */
.urlNotice-wrap {
  min-height: 100dvh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* 중앙 컨텐츠 정렬 */
.urlNotice-center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 20px 120px;
  /* 하단 버튼과 겹치지 않도록 여백 */
  box-sizing: border-box;
}

/* 아이콘 */
.urlNotice-icon {
  width: 108px;
  height: 108px;
  margin-bottom: 12px;
}

.urlNotice-iconSvg {
  width: 100%;
  height: 100%;
  display: block;
}

/* 텍스트 */
.urlNotice-title {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.02em;
  margin: 6px 0 10px;
}

.urlNotice-desc {
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}

/* 하단 고정 버튼 바 */
.urlNotice-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
  background: #ffffff;
  box-sizing: border-box;
  /* 필요시 테두리: */
  /* border-top: 1px solid #e5e7eb; */
}

/* 버튼 스타일(요청하신 값 그대로) */
.urlNotice-btn {
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 14px 10px;
  background: #0b3a6f;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.urlNotice-btn:active {
  transform: translateY(1px);
  opacity: 0.95;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/mobile.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,0EAA0E;EAC1E,WAAW;AACb;;AAEA,WAAW;AACX;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,QAAQ;AACR;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,cAAc;EACd,qGAAqG;AACvG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,qGAAqG;AACvG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;;;;;AAMA,uCAAuC;AACvC;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,2HAA2H;AAC7H;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA,+CAA+C;AAC/C;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,sBAAsB;EACtB;AACF;;AAEA,wCAAwC;AACxC;EACE;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR;AACF;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB,2DAA2D;AAC3D;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,qEAAqE;EACrE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,8DAA8D;AAC9D;EACE;AACF;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;EAC/B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB;AACF;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,2DAA2D;EAC3D,oCAAoC;EACpC,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;;;;AAKA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2DAA2D;EAC3D,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf","sourcesContent":[".myMenu {\r\n  width: 100%;\r\n}\r\n\r\n.myMenu-title {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #444;\r\n  display: inline-block;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.myMenu-swiper {\r\n  padding: 6px 0;\r\n}\r\n\r\n/* 칩 버튼 */\r\n.myMenu-slide {\r\n  width: auto;\r\n  /* slidesPerView=\"auto\"일 때 칩 크기만큼 */\r\n}\r\n\r\n.myMenu-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 14px;\r\n  border-radius: 9999px;\r\n  border: 1px solid rgba(22, 99, 156, 0.10);\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n  white-space: nowrap;\r\n  transition: transform .06s ease, background .15s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.myMenu-chip:active {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.myMenu-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n  background: #E6F0F8;\r\n  display: grid;\r\n  place-items: center;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.myMenu-label {\r\n  color: #1F2A37;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n/* (선택) 스크롤바 최소화 - WebKit */\r\n.myMenu-swiper::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n\r\n.myMenu-swiper::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.15);\r\n  border-radius: 999px;\r\n}\r\n\r\n.myMenu-swiper .swiper-slide {\r\n  width: auto !important;\r\n  /* slidesPerView=\"auto\"와 세트 */\r\n  display: inline-flex;\r\n  /* 칩 너비만큼만 차지 */\r\n  flex-shrink: 0;\r\n}\r\n\r\n.swiper-wrapper {\r\n  height: auto !important;\r\n  margin-bottom: 10px !important;\r\n}\r\n\r\n/* mobile-dashboard.css */\r\n.mobile-dashboard-panel {\r\n  width: 100%;\r\n  padding: 30px 20px 10px;\r\n  box-sizing: border-box;\r\n  background: linear-gradient(160deg, #0b3a6f 0%, #0d2b53 60%, #08223f 100%);\r\n  color: #fff;\r\n}\r\n\r\n/* 상단 텍스트 */\r\n.mobile-dashboard-welcome {\r\n  padding: 6px 4px 14px;\r\n}\r\n\r\n.mobile-dashboard-welcome-title {\r\n  font-size: 20px;\r\n  line-height: 1.3;\r\n  font-weight: 700;\r\n  margin: 0 0 6px 0;\r\n  letter-spacing: -0.2px;\r\n}\r\n\r\n.mobile-dashboard-welcome-sub {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.mobile-dashboard-welcome-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  font-size: 13px;\r\n  color: #d7e2ef;\r\n}\r\n\r\n/* 잔고 카드 */\r\n.mobile-dashboard-balance-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 14px 16px 12px;\r\n  color: #0d1b2a;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\r\n  /* max-width: 360px; */\r\n}\r\n\r\n.mobile-dashboard-balance-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mobile-dashboard-balance-label {\r\n  font-size: 12px;\r\n  color: #7a8a9e;\r\n  font-weight: 600;\r\n  letter-spacing: -0.2px;\r\n}\r\n\r\n.mobile-dashboard-balance-body {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.mobile-dashboard-balance-amount {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.mobile-dashboard-balance-amount .unit {\r\n  font-size: 18px;\r\n  margin-left: 2px;\r\n  font-weight: 600;\r\n}\r\n\r\n.mobile-dashboard-refresh-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 4px;\r\n  margin-left: 8px;\r\n  border-radius: 6px;\r\n  color: #0c3b70;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-dashboard-refresh-btn:active {\r\n  transform: scale(0.96);\r\n}\r\n\r\n.mobile-dashboard-refresh-btn:hover {\r\n  background: rgba(12, 59, 112, 0.08);\r\n}\r\n\r\n/* 반응형 */\r\n@media (max-width: 420px) {\r\n  .mobile-dashboard-panel {\r\n    border-radius: 0;\r\n    padding: 16px;\r\n  }\r\n\r\n  .mobile-dashboard-balance-card {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .mobile-dashboard-balance-amount {\r\n    font-size: 26px;\r\n  }\r\n}\r\n\r\n/* ===== 모달 전체 ===== */\r\n.modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.modal-sheet {\r\n  background: #fff;\r\n  width: 400px;\r\n  max-width: 90%;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\r\n  animation: fadeIn 0.2s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* ===== 모달 헤더 ===== */\r\n.modal-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 22px 20px 16px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-head h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.modal-close {\r\n  border: none;\r\n  background: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  color: #666;\r\n}\r\n\r\n/* ===== 모달 바디 ===== */\r\n.modal-body {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.row-label {\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n.row-content {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ===== 입력 ===== */\r\n.amount-input-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.amount-input {\r\n  flex: 1;\r\n  padding: 5px 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n  text-align: right;\r\n}\r\n\r\n.amount-suffix {\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.btn-all {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  background: #f1f1f1;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-all:hover {\r\n  background: #e2e2e2;\r\n}\r\n\r\n/* ===== 에러 메시지 ===== */\r\n.field-error {\r\n  font-size: 12px;\r\n  color: #d33;\r\n}\r\n\r\n/* ===== 모달 푸터 ===== */\r\n.modal-foot {\r\n  padding: 16px 20px;\r\n  border-top: 1px solid #eee;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.btn-transfer {\r\n  background: #004080;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 10px 20px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.btn-transfer:hover {\r\n  background: #003366;\r\n}\r\n\r\n.btn-transfer.btn-disabled {\r\n  background: #bbb;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.mobile-date {\r\n  font-size: 14px;\r\n}\r\n\r\n.mobile-date-btn:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n/* MobileCreateInfo.css */\r\n.mobile-url-create-wrap {\r\n  background: #fff;\r\n  color: #111827;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans KR\", Arial, sans-serif;\r\n}\r\n\r\n.mobile-url-create-title {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mobile-url-create-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.mobile-url-create-label {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.mobile-url-create-image-row {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.mobile-url-create-image-box,\r\n.mobile-url-create-image-picker {\r\n  width: 120px;\r\n  height: 90px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: #f9fafb;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.mobile-url-create-image-box img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 5px;\r\n}\r\n\r\n.mobile-url-create-image-picker {\r\n  cursor: pointer;\r\n  background: #ffffff;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.mobile-url-create-plus {\r\n  width: 26px;\r\n  height: 26px;\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.mobile-url-create-plus::before,\r\n.mobile-url-create-plus::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  background: #9ca3af;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.mobile-url-create-plus::before {\r\n  width: 2px;\r\n  height: 20px;\r\n}\r\n\r\n.mobile-url-create-plus::after {\r\n  width: 20px;\r\n  height: 2px;\r\n}\r\n\r\n.mobile-url-create-form {\r\n  margin-top: 10px;\r\n  display: grid;\r\n  gap: 7px;\r\n}\r\n\r\n.mobile-url-create-field {\r\n  display: grid;\r\n  gap: 1px;\r\n}\r\n\r\n.mobile-url-create-field-label {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.mobile-url-create-input,\r\n.mobile-url-create-textarea,\r\n.mobile-url-create-select {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 0px 12px;\r\n  height: 34px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: #ffffff;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.mobile-url-create-input::placeholder,\r\n.mobile-url-create-textarea::placeholder {\r\n  color: #9ca3af;\r\n}\r\n\r\n.mobile-url-create-textarea {\r\n  resize: vertical;\r\n  min-height: 88px;\r\n}\r\n\r\n/* 셀렉트 + 케럿 */\r\n.mobile-url-create-select-wrap {\r\n  position: relative;\r\n}\r\n\r\n.mobile-url-create-select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n}\r\n\r\n.mobile-url-create-caret {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n  border-top: 6px solid #6b7280;\r\n  transform: translateY(-50%);\r\n  pointer-events: none;\r\n}\r\n\r\n.mobile-url-create-divider {\r\n  height: 5px;\r\n  background: #f3f4f6;\r\n  margin: 0px -20px 14px;\r\n}\r\n\r\n.mobile-url-create-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.mobile-url-create-btn {\r\n  flex: 1;\r\n  height: 44px;\r\n  border-radius: 6px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-url-create-btn.primary {\r\n  background: #003577;\r\n  /* 딥 블루-민트 */\r\n  color: #fff;\r\n  border-color: #003577;\r\n}\r\n\r\n.mobile-url-create-btn.ghost {\r\n  background: #fff;\r\n  color: #374151;\r\n}\r\n\r\n.mobile-url-create-btn:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n/* 설명 이미지 썸네일 그리드 */\r\n.mobile-url-create-desc-row {\r\n  margin: 8px 0 6px;\r\n}\r\n\r\n.mobile-url-create-thumb-grid {\r\n  margin-top: 6px;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.mobile-url-create-thumb {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 75%;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  background: #f9fafb;\r\n}\r\n\r\n.mobile-url-create-thumb img {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.mobile-url-create-thumb-remove {\r\n  position: absolute;\r\n  top: 4px;\r\n  right: 4px;\r\n  width: 22px;\r\n  height: 22px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background: rgba(17, 24, 39, 0.65);\r\n  color: #fff;\r\n  line-height: 22px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-url-create-sublabel {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  margin: 4px 0 6px;\r\n}\r\n\r\n.mobile-url-create-image-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n/* 대표이미지 박스 */\r\n.mobile-url-create-image-box-rep {\r\n  position: relative;\r\n}\r\n\r\n.mobile-url-create-image-box-rep img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* MobileManagement.css */\r\n.mobile-management-wrap {\r\n  padding: 70px 16px 16px;\r\n  background: #fff;\r\n  color: #111827;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans KR\", Arial, sans-serif;\r\n}\r\n\r\n.mobile-management-heading {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mobile-management-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 14px;\r\n}\r\n\r\n.mobile-management-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.mobile-management-thumb {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  /* 1:1 */\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #f3f4f6;\r\n}\r\n\r\n.mobile-management-thumb img {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.mobile-management-like {\r\n  position: absolute;\r\n  right: 8px;\r\n  bottom: 8px;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border: 1px solid #e5e7eb;\r\n  display: grid;\r\n  place-items: center;\r\n  color: #6b7280;\r\n}\r\n\r\n.mobile-management-title {\r\n  margin: 8px 2px 6px;\r\n  font-size: 14px;\r\n  line-height: 1.35;\r\n  font-weight: 500;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  /* 2줄 말줄임 */\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.mobile-management-price-row {\r\n  margin: 0 2px 4px;\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: baseline;\r\n}\r\n\r\n.mobile-management-discount {\r\n  color: #ef4444;\r\n  /* 붉은 할인 퍼센트 */\r\n  font-weight: 800;\r\n  font-size: 14px;\r\n}\r\n\r\n.mobile-management-price {\r\n  font-weight: 800;\r\n  font-size: 16px;\r\n}\r\n\r\n.mobile-management-myprice {\r\n  margin: 0 2px 6px;\r\n  color: #ef4444;\r\n  font-size: 12px;\r\n}\r\n\r\n.mobile-management-myprice strong {\r\n  font-weight: 800;\r\n}\r\n\r\n.mobile-management-badges {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  margin: 2px 2px 0;\r\n}\r\n\r\n.mobile-management-badge {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  background: #f3f4f6;\r\n  padding: 4px 6px;\r\n  border-radius: 999px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* ============== Base ============== */\r\n.urlDetail-wrap {\r\n  --ui-text: #111;\r\n  --ui-muted: #6b7280;\r\n  --ui-line: #e5e7eb;\r\n  --ui-primary: #0b3a6f;\r\n  /* 페이지 하단 결제/모달 버튼 */\r\n  --ui-red: #ef4444;\r\n  --ui-cta: #fbbf24;\r\n  background: #fff;\r\n  color: var(--ui-text);\r\n  line-height: 1.4;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans KR\", \"Malgun Gothic\", Pretendard, sans-serif;\r\n}\r\n\r\n/* ============== Hero (single image) ============== */\r\n.urlDetail-hero {\r\n  position: relative;\r\n  background: #fff\r\n}\r\n\r\n.urlDetail-heroImg {\r\n  width: 100%;\r\n  display: block;\r\n  aspect-ratio: 12/9;\r\n  object-fit: cover\r\n}\r\n\r\n/* ============== Title / Meta ============== */\r\n.urlDetail-titleBox {\r\n  padding: 18px 16px 4px\r\n}\r\n\r\n.urlDetail-title {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  word-break: keep-all\r\n}\r\n\r\n.urlDetail-origin {\r\n  color: var(--ui-muted);\r\n  font-weight: 500;\r\n  margin-left: 4px\r\n}\r\n\r\n.urlDetail-ratingLine {\r\n  margin-top: 6px;\r\n  color: var(--ui-red);\r\n  font-weight: 700\r\n}\r\n\r\n.urlDetail-star {\r\n  margin-right: 4px\r\n}\r\n\r\n.urlDetail-recent,\r\n.urlDetail-reviews {\r\n  color: var(--ui-muted);\r\n  font-weight: 500\r\n}\r\n\r\n/* ============== Price ============== */\r\n.urlDetail-priceBox {\r\n  padding: 8px 16px 0\r\n}\r\n\r\n.urlDetail-priceRow {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 10px\r\n}\r\n\r\n.urlDetail-priceRow--strike {\r\n  color: var(--ui-muted);\r\n  margin-top: 6px\r\n}\r\n\r\n.urlDetail-discount {\r\n  color: var(--ui-red);\r\n  font-size: 18px\r\n}\r\n\r\n.urlDetail-listPrice {\r\n  text-decoration: line-through\r\n}\r\n\r\n.urlDetail-salePrice {\r\n  font-size: 28px;\r\n  font-weight: 800;\r\n  letter-spacing: -.5px\r\n}\r\n\r\n.urlDetail-myPrice {\r\n  margin-top: 6px;\r\n  color: var(--ui-red);\r\n  font-weight: 800\r\n}\r\n\r\n.urlDetail-myPrice span {\r\n  margin-left: 6px;\r\n  font-size: 13px;\r\n  font-weight: 700\r\n}\r\n\r\n.urlDetail-shipLine {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  gap: 8px;\r\n  color: var(--ui-muted)\r\n}\r\n\r\n.urlDetail-freeShip {\r\n  padding: 2px 8px;\r\n  border: 1px solid var(--ui-line);\r\n  border-radius: 999px;\r\n  color: #4b5563;\r\n  background: #fff\r\n}\r\n\r\n.urlDetail-unit {\r\n  color: var(--ui-muted)\r\n}\r\n\r\n/* ============== Benefit + 배송(원복) ============== */\r\n.urlDetail-benefitWrap {\r\n  padding: 14px 16px;\r\n  display: grid;\r\n  gap: 8px\r\n}\r\n\r\n.urlDetail-benefit {\r\n  background: #ede9fe;\r\n  color: #4f46e5;\r\n  font-weight: 700;\r\n  padding: 10px 12px;\r\n  border-radius: 12px\r\n}\r\n\r\n.urlDetail-delivery {\r\n  background: #ecfeff;\r\n  color: #0ea5b7;\r\n  font-weight: 700;\r\n  padding: 10px 12px;\r\n  border-radius: 12px\r\n}\r\n\r\n.urlDetail-nologo {\r\n  display: inline-block;\r\n  margin-right: 6px\r\n}\r\n\r\n/* ============== Tabs (상세정보만) ============== */\r\n.urlDetail-tabs {\r\n  display: flex;\r\n  gap: 16px;\r\n  padding: 12px 16px;\r\n  border-top: 8px solid #f5f5f6;\r\n  border-bottom: 1px solid var(--ui-line);\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-tab {\r\n  font-weight: 700;\r\n  color: #111;\r\n  padding-bottom: 5px;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.urlDetail-tab.is-active {\r\n  border-bottom-color: #111;\r\n}\r\n\r\n/* ✅ after 없이 밑줄 */\r\n\r\n/* ============== Detail (상품정보 + 이미지 + 토글) ============== */\r\n.urlDetail-detailBody {\r\n  position: relative\r\n}\r\n\r\n.urlDetail-detailInner {\r\n  padding: 6px 0 0\r\n}\r\n\r\n.urlDetail-detailImg {\r\n  width: 100%;\r\n  display: block\r\n}\r\n\r\n/* 접힘 높이 400px */\r\n.urlDetail-detailBody.is-closed .urlDetail-detailInner {\r\n  max-height: 400px;\r\n  overflow: hidden\r\n}\r\n\r\n.urlDetail-detailFade {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 50px;\r\n  height: 30px;\r\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 55%);\r\n  pointer-events: none;\r\n}\r\n\r\n/* 상품정보 블록 */\r\n.urlDetail-spec {\r\n  padding: 16px\r\n}\r\n\r\n.urlDetail-specTitle {\r\n  font-size: 16px;\r\n  font-weight: 800;\r\n  margin-bottom: 8px\r\n}\r\n\r\n.urlDetail-specTable {\r\n  display: grid;\r\n  grid-template-columns: 90px 1fr;\r\n  row-gap: 8px;\r\n  column-gap: 12px\r\n}\r\n\r\n.urlDetail-specTable dt {\r\n  color: var(--ui-muted)\r\n}\r\n\r\n.urlDetail-specTable dd {\r\n  color: #111\r\n}\r\n\r\n.urlDetail-spec--inDetail {\r\n  border-bottom: 1px solid var(--ui-line);\r\n  margin-bottom: 8px\r\n}\r\n\r\n/* 토글 버튼 */\r\n.urlDetail-detailToggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  width: calc(100% - 32px);\r\n  margin: 12px auto 16px;\r\n  padding: 13px 12px;\r\n  background: #fff;\r\n  border: 1px solid #000;\r\n  border-radius: 12px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.urlDetail-toggleIcon {\r\n  transition: transform .18s ease\r\n}\r\n\r\n.urlDetail-toggleIcon.is-open {\r\n  transform: rotate(180deg)\r\n}\r\n\r\n.urlDetail-toggleText {\r\n  display: inline-block\r\n}\r\n\r\n/* ============== Buy bar (하단 결제 버튼, #0b3a6f) ============== */\r\n.urlDetail-bottomPad {\r\n  height: 78px\r\n}\r\n\r\n.urlDetail-buybar {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 40;\r\n  display: grid;\r\n  gap: 8px;\r\n  grid-template-columns: 1fr;\r\n  padding: 10px 12px 15px;\r\n  background: #fff;\r\n  border-top: 1px solid var(--ui-line);\r\n}\r\n\r\n.urlDetail-buyBtn {\r\n  all: unset;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--ui-primary);\r\n  color: #fff;\r\n  font-weight: 900;\r\n  border-radius: 12px;\r\n  padding: 16px 10px;\r\n  font-size: 17px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ============== Bottom Sheet (바텀시트 공통) ============== */\r\n.urlDetail-sheet {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 90;\r\n  pointer-events: none\r\n}\r\n\r\n.urlDetail-sheet.is-open {\r\n  pointer-events: auto\r\n}\r\n\r\n.urlDetail-sheetDim {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, .45);\r\n  opacity: 0;\r\n  transition: opacity .2s ease\r\n}\r\n\r\n.urlDetail-sheet.is-open .urlDetail-sheetDim {\r\n  opacity: 1\r\n}\r\n\r\n.urlDetail-sheetPanel {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: #fff;\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  box-shadow: 0 -12px 24px rgba(0, 0, 0, .18);\r\n  transform: translateY(100%);\r\n  transition: transform .28s ease;\r\n  padding-bottom: env(safe-area-inset-bottom)\r\n}\r\n\r\n.urlDetail-sheet.is-open .urlDetail-sheetPanel {\r\n  transform: translateY(0)\r\n}\r\n\r\n.urlDetail-sheetHandle {\r\n  width: 44px;\r\n  height: 4px;\r\n  background: #e5e7eb;\r\n  border-radius: 999px;\r\n  margin: 10px auto 6px\r\n}\r\n\r\n.urlDetail-sheetBody {\r\n  padding: 12px 16px\r\n}\r\n\r\n/* ============== 모달: 카드 + 총 결제 + 하단 버튼 ============== */\r\n.urlDetail-payCard {\r\n  margin: 20px 16px 0;\r\n  padding: 0 5px;\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-payHeader {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 8px\r\n}\r\n\r\n.urlDetail-payText {\r\n  min-width: 0\r\n}\r\n\r\n.urlDetail-payTitle {\r\n  display: block;\r\n  font-weight: 800\r\n}\r\n\r\n.urlDetail-payBrand {\r\n  margin-top: 2px;\r\n  color: var(--ui-muted);\r\n  font-weight: 600;\r\n  font-size: 13px\r\n}\r\n\r\n.urlDetail-payClose {\r\n  all: unset;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  padding: 4px;\r\n  cursor: pointer\r\n}\r\n\r\n.urlDetail-payRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 10px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid var(--ui-line)\r\n}\r\n\r\n.urlDetail-payPrice {\r\n  font-weight: 800\r\n}\r\n\r\n.urlDetail-totalRow {\r\n  margin: 0px 16px;\r\n  padding: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-total {\r\n  font-weight: 900\r\n}\r\n\r\n.urlDetail-sheetBuybar {\r\n  position: sticky;\r\n  bottom: 0;\r\n  background: #fff;\r\n  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));\r\n  border-top: 1px solid var(--ui-line);\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 8px;\r\n}\r\n\r\n.urlDetail-ellipsis {\r\n  max-width: 86vw;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis\r\n}\r\n\r\n.urlDetail-muted {\r\n  color: var(--ui-muted)\r\n}\r\n\r\n/* ===== 모달 수량 스텝퍼 ===== */\r\n.urlDetail-qtyCard {\r\n  margin: 12px 16px;\r\n}\r\n\r\n.urlDetail-qtyRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid var(--ui-line);\r\n  border-bottom: none;\r\n  border-top-left-radius: 12px;\r\n  border-top-right-radius: 12px;\r\n  padding: 12px 12px 6px;\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-qtyTitle {\r\n  font-weight: 800;\r\n}\r\n\r\n.urlDetail-stepper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.urlDetail-stepBtn {\r\n  width: 42px;\r\n  height: 42px;\r\n  border: 1px solid var(--ui-line);\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.urlDetail-stepBtn:first-child {\r\n  border-top-left-radius: 12px;\r\n  border-bottom-left-radius: 12px;\r\n}\r\n\r\n.urlDetail-stepBtn:last-child {\r\n  border-top-right-radius: 12px;\r\n  border-bottom-right-radius: 12px;\r\n}\r\n\r\n.urlDetail-stepBtn:disabled {\r\n  opacity: .5;\r\n  cursor: not-allowed;\r\n  background: #fafafa;\r\n}\r\n\r\n.urlDetail-stepValue {\r\n  width: 56px;\r\n  height: 42px;\r\n  border-top: 1px solid var(--ui-line);\r\n  border-bottom: 1px solid var(--ui-line);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 800;\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-qtySummary {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid var(--ui-line);\r\n  border-top: none;\r\n  border-bottom-left-radius: 12px;\r\n  border-bottom-right-radius: 12px;\r\n  padding: 12px;\r\n  background: #fff;\r\n}\r\n\r\n.urlDetail-accent {\r\n  color: var(--ui-red);\r\n}\r\n\r\n\r\n\r\n\r\n/* 래퍼: 헤더 높이(3.5rem) 아래부터 전체 화면 채움 */\r\n.urlNotice-wrap {\r\n  min-height: 100dvh;\r\n  background: #ffffff;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* 중앙 컨텐츠 정렬 */\r\n.urlNotice-center {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 24px 20px 120px;\r\n  /* 하단 버튼과 겹치지 않도록 여백 */\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* 아이콘 */\r\n.urlNotice-icon {\r\n  width: 108px;\r\n  height: 108px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.urlNotice-iconSvg {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n}\r\n\r\n/* 텍스트 */\r\n.urlNotice-title {\r\n  font-size: 22px;\r\n  font-weight: 800;\r\n  color: #111827;\r\n  letter-spacing: -0.02em;\r\n  margin: 6px 0 10px;\r\n}\r\n\r\n.urlNotice-desc {\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n  color: #6B7280;\r\n}\r\n\r\n/* 하단 고정 버튼 바 */\r\n.urlNotice-bottom {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  padding: 12px 20px calc(12px + env(safe-area-inset-bottom));\r\n  background: #ffffff;\r\n  box-sizing: border-box;\r\n  /* 필요시 테두리: */\r\n  /* border-top: 1px solid #e5e7eb; */\r\n}\r\n\r\n/* 버튼 스타일(요청하신 값 그대로) */\r\n.urlNotice-btn {\r\n  width: 100%;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 14px 10px;\r\n  background: #0b3a6f;\r\n  color: #fff;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.urlNotice-btn:active {\r\n  transform: translateY(1px);\r\n  opacity: 0.95;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
